import React from 'react'

import './Disclaimer.scss'

const includeModifier = (def, mod) => {
  return `${def} ${mod ? `${def}${mod}` : ''}`
}

function Disclaimer ({
  className = '',
  heading = null,
  media = null,
  showHeading = false,
  showMediaWhenSmall = true,
  message = null,
  subtext = null,
  tertiary = null,
  modifier = null
}) {
  return (
    <section className={`${includeModifier('Disclaimer', modifier)} ${className}`}>
      {media
        ? <div className={`${includeModifier('Disclaimer__media', modifier)} ${showMediaWhenSmall ? 'Disclaimer__media--show-small' : ''}`}>
          {media}
        </div>
        : null}
      <div className={includeModifier('Disclaimer__content', modifier)}>
        {showHeading && heading
          ? <h3 className={includeModifier('Disclaimer__title', modifier)}>
            {heading}
          </h3>
          : null}
        {message ? <div className={includeModifier('Disclaimer__message', modifier)}>{message}</div> : null}
        {subtext ? <div className={includeModifier('Disclaimer__subtext', modifier)}>{subtext}</div> : null}
      </div>
      {tertiary
        ? <div className={includeModifier('Disclaimer__tertiary', modifier)}>
        {tertiary}
      </div>
        : null}
    </section>
  )
}

export default Disclaimer
